<template lang="pug">
.res-popup
  .wrapper
    close-btn(@clicked="setShowLatestResPopup(false)")
    .title 预约信息
    .subtitle
    .dates
      .date {{year}}年{{month}}月{{date}}日
      time-range(:fs1="30" :fs2="90" :schedule="res.schedule")
    .split
    .fam
      avatar-stack
      .copy {{avatars.length}}位参观者
    .btn-detail(@click="onToDetail") 查看详情



</template>
<script>
import CloseBtn from '@/components/wedgits/CloseBtn'
import TimeRange from '@/components/wedgits/TimeRange'
import AvatarStack from '@/components/wedgits/AvatarStack'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'LatestResPopup',
  components: { AvatarStack, TimeRange, CloseBtn },
  props: {
    title: {},
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('app', ['getLatestValidRes']),
    res() {
      return this.getLatestValidRes
    },
    year() {
      return this.res.schedule.from.getFullYear()
    },
    month() {
      return this.res.schedule.from.getMonth() + 1
    },
    date() {
      return this.res.schedule.from.getDate()
    },
    avatars() {
      // return this.fams.map((u) => {
      //   return u.avatar
      // })
      return this.res.users.map((u) => {
        return u.avatar
      })
    },
  },
  methods: {
    ...mapMutations('app', ['setShowLatestResPopup', 'setRouterBack']),
    onToDetail() {
      this.setShowLatestResPopup(false)
      this.setRouterBack('/')
      this.$router.replace(`/me/res/${this.res.resId}`)
    },
  },
  mounted() {
    console.log('ppp', this.res)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.res-popup
  position: fixed
  width: 100%
  height: 100%
  z-index: 9999
  top: 0
  left: 0
  +flex-center
  background: rgba(0, 0, 0, 0.46)
  animation: fadeIn 0.5s $easeOutCubic both
  .wrapper
    width: 85%
    //height: 55%
    //height: pxToRem(229)
    background: white
    border-radius: pxToRem(20)
    position: relative
    padding: pxToRem(30)
    display: flex
    align-items: center
    flex-direction: column
    font-size: pxToRem(40)
    color: black
    .close-btn
      right: pxToRem(40)
      top: pxToRem(40)
    .title
      text-align: center
      width: 100%
      //padding: pxToRem(40)
      //font-size: pxToRem(40)
      //color: black
      margin-top: pxToRem(20)
      margin-bottom: pxToRem(60)
    .dates
      .date
        //font-size: pxToRem(36)
        font-family: $ff-cn
        line-height: pxToRem(50)
        letter-spacing: pxToRem(0.8)
    .split
      width: 100%
      height: 1px
      background: #dddddd
      margin: pxToRem(30) 0
    .fam
      width: 100%
      display: flex
      justify-content: space-between
      align-items: center
      flex-direction: row
      .copy
        font-size: pxToRem(26)
        color: black
    .btn-detail
      margin-top: pxToRem(100)
      bottom: pxToRem(20)
      width: 100%
      height: pxToRem(100)
      border-radius: pxToRem(8)
      border: 1px $cl-blue solid
      color: $cl-blue
      font-size: pxToRem(40)
      display: flex
      align-items: center
      justify-content: center
@keyframes fadeIn
  0%
    transform: scale(1.2)
    opacity: 0
  100%
    transform: scale(1)
    opacity: 1
</style>
